/**
 * Faz 9: Active session shared bridge — diğer sayfalar (file-transfer,
 * meeting) aktif oturum bilgilerine erişsin diye global state. Session
 * page mount olduğunda set, unmount olduğunda clear.
 */
class ActiveSessionStore {
    current = null;
    listeners = new Set();
    get() {
        return this.current;
    }
    set(session) {
        this.current = session;
        for (const l of this.listeners)
            l();
    }
    subscribe(fn) {
        this.listeners.add(fn);
        return () => this.listeners.delete(fn);
    }
}
export const activeSession = new ActiveSessionStore();
